import React, { useEffect, useState } from "react";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { lightBlue } from "@mui/material/colors";

import ShareIcon from "@mui/icons-material/Share";
import ModalShare from "./ModalShare";
import useNews from "../../hooks/useNews";
import { isVideov2 } from "../../helpers/isVideo";

function CardBlog({ noticia, loading }) {
  const user = JSON.parse(localStorage.getItem("Usuario"))?.UserLogin._id;
  const initialLikes = noticia
    ? noticia?.likes?.some((like) => like === user)
    : false;
  const initialCountLikes = noticia ? noticia?.likes?.length : 0;

  const [boton, setBoton] = useState(initialLikes);
  const [countLikes, setCountLikes] = useState(initialCountLikes);

  const [show, setShow] = useState(false);
  const { editLikes } = useNews();

  const onOpen = () => {
    setShow(true);
    document.body.style.overflow = "hidden";
  };

  const onClose = () => {
    setShow(false);
    document.body.style.overflow = "auto";
  };

  const like = (e) => {
    e.preventDefault();
    if (user) {
      editLikes({ newsId: noticia?._id, userId: user });
      setCountLikes((prevCountLikes) => {
        if (boton) {
          return prevCountLikes - 1;
        } else {
          return prevCountLikes + 1;
        }
      });
      setBoton(!boton);
    }
  };

  const [newTitle, setNewTitle] = useState("");
  const { title } = noticia ? noticia : "";

  const changeUrl = (title) => {
    const newTitulo = title?.replaceAll(" ", "-").toLowerCase();
    setNewTitle(newTitulo);
  };

  useEffect(() => {
    changeUrl(title);
  }, [title]);

  const SkeletonLoaderCardNews = () => {
    return (
      <section className="container-card-img-blog">
        <article className="skeleton card-img-blog">
          <h3>{noticia.category}</h3>
          <h1>{noticia.title}</h1>
          <div className="skeleton container-mg">
            <button onClick={like}>
              {boton ? (
                <FavoriteIcon sx={{ color: lightBlue[500] }} />
              ) : (
                <FavoriteBorderIcon sx={{ color: lightBlue[500] }} />
              )}
            </button>
            <p>{noticia.visitas}</p>
          </div>
          {noticia.multimedia ? (
            <div className="container-iframe">
              <iframe
                src={noticia.video}
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              ></iframe>
            </div>
          ) : (
            <img
              src={noticia.imageCover ? noticia.imageCover[0]?.url : ""}
              alt={
                noticia.imageCover ? noticia.imageCover[0]?.alt : noticia?.title
              }
            />
          )}
        </article>
      </section>
    );
  };

  const urlBlog = noticia.title.replaceAll(" ", "-");

  return loading ? (
    <section
      className={`container-notice-share ${
        show ? "container-notice-share-blur" : ""
      }`}
    >
      {!show && (
        <div className="redireccion cardBlog-link">
          <section className="container-card-img-blog">
            <article className="card-img-blog">
              <h3>{noticia.category}</h3>
              <div>
                <a
                  href={
                    !noticia.multimedia
                      ? `/nueva-noticias/${newTitle}`
                      : `/nueva-noticias-multimedia/${newTitle}`
                  }
                  className="redireccion cardBlog-link"
                >
                  <h1>{noticia.title}</h1>
                </a>
              </div>
              <div className="container-mg">
                <button onClick={like}>
                  {boton ? (
                    <FavoriteIcon sx={{ color: lightBlue[500] }} />
                  ) : (
                    <FavoriteBorderIcon sx={{ color: lightBlue[500] }} />
                  )}
                </button>
                <p>{countLikes}</p>
              </div>
              {noticia.multimedia ? (
                <a
                  href={
                    !noticia.multimedia
                      ? `/nueva-noticias/${newTitle}`
                      : `/nueva-noticias-multimedia/${newTitle}`
                  }
                  className="redireccion cardBlog-link"
                >
                  <div className="container-iframe">
                    <iframe
                      title={noticia?.title}
                      srcDoc={`
                        <style>
                            body, .full {
                                width: 100%;
                                height: 100%;
                                margin: 0;
                                position: absolute;
                                display: flex;
                                justify-content: center;
                                object-fit: cover;
                            }
                        </style>
                        <a
                            href='${noticia.video}?autoplay=1'
                            class='full'
                        >
                            <img
                                src='http://img.youtube.com/vi/${noticia.video?.replace(
                                  "https://www.youtube.com/embed/",
                                  ""
                                )}/0.jpg'
                                class='full'
                            />
                            <svg
                                version='1.1'
                                viewBox='0 0 68 48'
                                width='68px'
                                style='position: relative;'
                            >
                                <path d='M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z' fill='#f00'></path>
                                <path d='M 45,24 27,14 27,34' fill='#fff'></path>
                            </svg>
                        </a>
                    `}
                      style={{
                        maxWidth: "640px",
                        width: "100%",
                        aspectRatio: "16/9",
                      }}
                      allow="autoplay *; accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    ></iframe>
                  </div>
                </a>
              ) : (
                <a
                  href={
                    !noticia.multimedia
                      ? `/nueva-noticias/${newTitle}`
                      : `/nueva-noticias-multimedia/${newTitle}`
                  }
                  className="redireccion cardBlog-link"
                >
                  {isVideov2(
                    noticia?.imageCover ? noticia?.imageCover[0]?.url : ""
                  ) ? (
                    <video
                      src={
                        noticia?.imageCover ? noticia?.imageCover[0]?.url : ""
                      }
                      controls
                      style={{
                        width: "100%",
                        height: "100%",
                        margin: 0,
                        display: "flex",
                        justifyContent: "center",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <img
                      src={noticia.imageCover ? noticia.imageCover[0]?.url : ""}
                      alt={
                        noticia.imageCover
                          ? noticia.imageCover[0]?.alt
                          : noticia?.title
                      }
                    />
                  )}
                </a>
              )}
            </article>
          </section>
        </div>
      )}

      {!show && (
        <div className="btn-shared-container">
          <button className="btn" onClick={onOpen}>
            <ShareIcon sx={{ color: "white" }} />
          </button>
        </div>
      )}
      {show && (
        <ModalShare
          noticia={noticia}
          urlBlog={urlBlog}
          isOpen={show}
          onClose={onClose}
          onOpen={onOpen}
        />
      )}
    </section>
  ) : (
    <SkeletonLoaderCardNews />
  );
}

export default CardBlog;
